<template>
  <div class="pay-vip">pay-vip</div>
</template>

<script>
  export default {
    name: "PayVip"
  }
</script>

<style scoped>

</style>